import React from 'react';
import CloudExecutiveDashboard from './CloudExecutiveDashboard';

const AWSDashboard: React.FC = () => {
  return <CloudExecutiveDashboard provider="aws" />;
};

export default AWSDashboard;
